<script lang="ts">
const styles = _stylex_create({
  main: {
    minBlockSize: '70vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingInline: '1.5rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    inlineSize: '100%',
    maxInlineSize: '36rem',
  },
  label: {
    color: black.text,
    fontFamily: fonts.interface,
    fontSize: '2rem',
    fontWeight: 600,
  },
  controls: {
    display: 'flex',
    gap: '0.75rem',
  },
  input: {
    flex: 1,
    minInlineSize: 0,
    padding: '0.75rem 1rem',
    borderColor: black.background,
    borderStyle: 'solid',
    borderWidth: '3px',
    backgroundColor: yellow.background,
    color: black.text,
    fontFamily: fonts.interface,
    fontSize: '1.25rem',
    outline: 'none',
  },
  button: {
    paddingInline: '1.5rem',
    border: 'none',
    backgroundColor: black.background,
    color: black.contrast,
    cursor: 'pointer',
    fontFamily: fonts.interface,
    fontSize: '1.25rem',
    fontWeight: 600,
  },
})
</script>
<script setup lang="ts">
import __MACROS__stylex_attrs from "/vue-macros/define-stylex/stylex-attrs";
import { create as _stylex_create, props as _stylex_props } from '@stylexjs/stylex'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { black, yellow } from '@/utils/colors.stylex'
import { fonts } from '@/utils/fonts.stylex'

const ticketNumber = ref('')
const router = useRouter()



function openTicket() {
  const id = ticketNumber.value.trim().replace(/^#/, '').trim()
  if (!id)
    return

  router.push({ name: 'ticket', params: { id } })
}
</script>

<template>
  <main v-bind="__MACROS__stylex_attrs(_stylex_props(styles.main))">
    <form v-bind="__MACROS__stylex_attrs(_stylex_props(styles.form))" @submit.prevent="openTicket">
      <label v-bind="__MACROS__stylex_attrs(_stylex_props(styles.label))" for="ticket-number">查询工单</label>
      <div v-bind="__MACROS__stylex_attrs(_stylex_props(styles.controls))">
        <input
          id="ticket-number"
          v-model="ticketNumber"
          v-bind="__MACROS__stylex_attrs(_stylex_props(styles.input))"
          name="ticket-number"
          placeholder="#TN-1111GpUb"
          autocomplete="off"
          autofocus
        >
        <button v-bind="__MACROS__stylex_attrs(_stylex_props(styles.button))" type="submit">
          查询
        </button>
      </div>
    </form>
  </main>
</template>
